module.exports = __webpack_public_path__ + "img/McD_Unternehmen_Content_images_01.d52b2b25.jpg";